import { Flex, Icon, Link, Menu, MenuButton, MenuItem, MenuList, Text, Tooltip } from '@chakra-ui/react'
import { Link as ReactLink } from 'react-router-dom'
import React, { Component } from 'react'
import { GoTriangleDown, GoTriangleLeft } from 'react-icons/go'

class NavItem extends Component {
    constructor(props) {
        super(props)
        this.changeSubmenu = this.changeSubmenu.bind(this);
    }
    state = {
        isOpen: this.props.isOpen
    }


    changeSubmenu() {
        this.setState({ isOpen: !this.state.isOpen })
    }



    render() {
        return (

            <Menu placement="right">
                <Flex w="100%" onClick={this.props.onClick || null}>
                    <Flex w={1} borderRightRadius={5} position="absolute" h="50px" backgroundColor={this.props.active && "#1C3739"} />
                    <Tooltip label={this.props.navSize === "small" ? `${this.props.title}` : ""} placement="right">
                        <Link
                            as={ReactLink}
                            backgroundColor={this.props.active ? "#1C797E" : ""}
                            py={3}
                            _hover={{ textDecoration: "none", backgroundColor: "#1C797E" }}
                            w={"100%"}
                            mb={this.props.children ? 0 : 1}
                            to={this.props.href || ""}
                            onClick={(e) => {
                                if (this.props.children) {
                                    e.preventDefault();
                                    this.changeSubmenu();
                                }
                            }}

                        >

                            <MenuButton w="100%">
                                <Flex ml={8} mr={0}>
                                    <Icon as={this.props.icon} fontSize="xl" color={this.props.active ? "white" : "white"} />
                                    <Flex flexDir={"row"} alignContent={"space-between"}>
                                        <Flex>
                                            <Text ml={3} color={"white"} display={this.props.navSize === "small" ? "none" : "flex-start"}>{this.props.title}</Text>
                                        </Flex>
                                        {this.props.children ? (
                                            <Flex>
                                                <Icon as={this.state.isOpen ? GoTriangleDown : GoTriangleLeft}
                                                    fontSize="md"
                                                    display={this.props.navSize === "small" && "none"} ml={20} mt={1}
                                                    color="white" />
                                            </Flex>
                                        ) : ("")}
                                    </Flex>

                                </Flex>
                            </MenuButton>
                        </Link>
                    </Tooltip>
                </Flex>
                {this.props.navSize === "small" && this.props.children && (
                    <MenuList
                        flexDir={"column"}
                        h={180}
                        w={200}
                        justify={"center"}
                        backgroundColor={"#006064"}
                        borderRadius={"10px"}
                        color={"white"}
                        textAlign={"center"}
                        p={4}
                    >
                        {React.Children.map(this.props.children, child => {
                            return (<MenuItem _hover={{ backgroundColor: "#DDEBEA", color: "black" }}
                                _focus={{ backgroundColor: "#006064", color: "white" }}
                                rounded={5}
                                as={ReactLink} to={child.props.href}>
                                {child.props.title}
                            </MenuItem>)
                        })}

                    </MenuList>
                )}


                {this.state.isOpen && this.props.navSize === "large" ? (
                    <Flex
                        flexDir="column"
                        w="100%">
                        {this.props.children}
                    </Flex>
                ) : ""}

            </Menu>

        )
    }
}
export default NavItem;